import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { CACHE_SIZE_KILOBYTES } from '../constants/loggingConstants';

var LruCache = /*#__PURE__*/function () {
  function LruCache() {
    var max = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : CACHE_SIZE_KILOBYTES;

    _classCallCheck(this, LruCache);

    this.memorySize = 0;
    this.max = max;
    this.cache = new Map();
  }

  _createClass(LruCache, [{
    key: "length",
    get: function get() {
      return this.cache.size;
    }
  }, {
    key: "has",
    value: function has(key) {
      var item = this.cache.get(key);
      if (item) return true;
      return false;
    }
  }, {
    key: "get",
    value: function get(key) {
      var item = this.cache.get(key);

      if (item) {
        // refresh key
        this.cache["delete"](key);
        this.cache.set(key, item);
      }

      return item;
    }
  }, {
    key: "set",
    value: function set(key, val) {
      // refresh key
      if (this.cache.has(key)) {
        this._delete(key);
      } else if (this.memorySize >= this.max) {
        this._delete(this._first());
      }

      this.cache.set(key, val);
      this.memorySize += this._roughSizeOfObject(key) + this._roughSizeOfObject(val);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.memorySize = 0;
      this.cache = new Map();
    }
  }, {
    key: "_delete",
    value: function _delete(key) {
      var item = this.cache.get(key);
      this.cache["delete"](key);
      this.memorySize -= this._roughSizeOfObject(key) + this._roughSizeOfObject(item);
    }
  }, {
    key: "_first",
    value: function _first() {
      return this.cache.keys().next().value;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "_roughSizeOfObject",
    value: function _roughSizeOfObject(object) {
      var objectList = [];
      var stack = [object];
      var bytes = 0;

      while (stack.length) {
        var value = stack.pop();

        if (typeof value === 'boolean') {
          bytes += 4;
        } else if (typeof value === 'string') {
          bytes += value.length * 2;
        } else if (typeof value === 'number') {
          bytes += 8;
        } else if (value instanceof Date) {
          bytes += 32;
        } else if (_typeof(value) === 'object' && objectList.indexOf(value) === -1) {
          objectList.push(value); // eslint-disable-next-line guard-for-in,no-restricted-syntax

          for (var i in value) {
            stack.push(value[i]);
          }
        }
      }

      return bytes;
    }
  }]);

  return LruCache;
}();

export { LruCache as default };